<template>
  <div class='numeric-cycle'>
    <svg x="0px" y="0px" :height="`${height}px`" :width="`${width}px`" :viewBox="`0 0 48 48`">
      <path :d="getPath"/>
      <text :style='`fill: ${getColor}`' x='50%' y='51%' dominant-baseline="middle" text-anchor="middle" class='numeric-cycle__text'>{{data}}</text>
    </svg>
  </div>

</template>

<script>
export default {
  name: 'NumericCycles',
  props: {
    data: {
      type: Number,
      required: true,
      default: 0,
    },
    width: {
      type: Number,
      required: false,
      default: 32,
    },
    height: {
      type: Number,
      required: false,
      default: 32,
    },
  },
  computed: {
    getPath() {
      return 'M24,44c-2.8,0-5.4-0.5-7.8-1.6c-2.4-1-4.5-2.5-6.4-4.3c-1.8-1.8-3.2-3.9-4.3-6.4S4,26.8,4,24c0-1.4,0.1-2.8,0.4-4.1' +
        ' c0.3-1.3,0.7-2.6,1.2-3.9l2.2,2.2c-0.3,0.9-0.5,1.9-0.7,2.8C7.1,22.1,7,23,7,24c0,4.7,1.7,8.8,4.9,12c3.3,3.3,7.3,5,12.1,5' +
        ' s8.8-1.6,12-5c3.3-3.3,5-7.3,5-12s-1.6-8.8-5-12.1C32.8,8.7,28.7,7,24,7c-1,0-1.9,0.1-2.9,0.2s-1.9,0.4-2.8,0.7L16,5.6' +
        ' c1.3-0.5,2.5-0.8,3.8-1.2c1.3-0.3,2.6-0.4,4-0.4c2.8,0,5.4,0.5,7.8,1.6s4.6,2.5,6.4,4.3c1.8,1.8,3.3,3.9,4.3,6.4s1.6,5,1.6,7.8' +
        ' s-0.5,5.4-1.6,7.8c-1,2.4-2.5,4.6-4.3,6.3c-1.8,1.8-3.9,3.2-6.4,4.3C29.4,43.5,26.8,44,24,44z M10.6,13.1c-0.7,0-1.3-0.2-1.8-0.7' +
        ' c-0.5-0.5-0.7-1.1-0.7-1.8c0-0.7,0.2-1.3,0.7-1.8s1.1-0.7,1.8-0.7s1.3,0.2,1.8,0.7s0.7,1.1,0.7,1.8c0,0.7-0.2,1.3-0.7,1.8' +
        ' C11.9,12.8,11.3,13.1,10.6,13.1z';
    },
    getColor() {
      if (this.data <= 1) {
        return '#b9c6d1';
      }
      if (this.data <= 3) {
        return '#ff7f00';
      }
      return '#e0255e';
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.numeric-cycle {
  fill: var(--text-secondary);
  &__text {
    font-family: $font-family-semibold;
    font-size: $font-size-lg;
    padding-top: rem(5);
  }
}
</style>
